'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$FeatureCode$() {
  this.c6P = null;
  this.c6Q = false;
  this.c6N = null;
  this.c6O = false;
}
export { $c_Lpresto_types$FeatureCode$ as $c_Lpresto_types$FeatureCode$ };
$p = $c_Lpresto_types$FeatureCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$FeatureCode$;
/** @constructor */
function $h_Lpresto_types$FeatureCode$() {
}
export { $h_Lpresto_types$FeatureCode$ as $h_Lpresto_types$FeatureCode$ };
$h_Lpresto_types$FeatureCode$.prototype = $p;
$p.cIb = (function() {
  if ((!this.c6Q)) {
    this.c6P = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c6Q = true;
  }
  return this.c6P;
});
$p.adu = (function() {
  if ((!this.c6O)) {
    this.c6N = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c6O = true;
  }
  return this.c6N;
});
var $d_Lpresto_types$FeatureCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$FeatureCode$, "presto.types$FeatureCode$", ({
  a04: 1,
  D: 1
}));
export { $d_Lpresto_types$FeatureCode$ as $d_Lpresto_types$FeatureCode$ };
var $n_Lpresto_types$FeatureCode$;
function $m_Lpresto_types$FeatureCode$() {
  if ((!$n_Lpresto_types$FeatureCode$)) {
    $n_Lpresto_types$FeatureCode$ = new $c_Lpresto_types$FeatureCode$();
  }
  return $n_Lpresto_types$FeatureCode$;
}
export { $m_Lpresto_types$FeatureCode$ as $m_Lpresto_types$FeatureCode$ };
//# sourceMappingURL=presto.types$-Feature-Code$.js.map
